export default function scrollManager() {
  window.addEventListener('load', function() {
    setTimeout(function() {
      var scrollToElement = document.querySelector('[scroll-to-on-page-load]');
      if (scrollToElement) {
        scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 1);
  });
}
